import { useImportedStudyStore } from '../../stores/useImportedStudyStore';
import { openImportedStudyInViewport } from './openImportedStudyInViewport';

type SwitchImportedStudyArgs = {
  servicesManager: AppTypes.ServicesManager;
  commandsManager: AppTypes.CommandsManager;
  displaySetService: AppTypes.DisplaySetService;
  requestDisplaySetCreationForStudy: (
    displaySetService: AppTypes.DisplaySetService,
    StudyInstanceUID: string,
    madeInClient?: boolean
  ) => unknown;
};

/**
 * Activates an imported study in application state and loads its first series
 * into the active viewport.
 */
export async function switchImportedStudy(
  studyInstanceUID: string,
  {
    servicesManager,
    commandsManager,
    displaySetService,
    requestDisplaySetCreationForStudy,
  }: SwitchImportedStudyArgs
): Promise<void> {
  if (!useImportedStudyStore.getState().isImportedStudyUID(studyInstanceUID)) {
    return;
  }

  useImportedStudyStore.getState().setActiveStudy(studyInstanceUID);

  await requestDisplaySetCreationForStudy(displaySetService, studyInstanceUID, true);

  openImportedStudyInViewport(servicesManager, commandsManager, studyInstanceUID);
}
